import { BrowserModule } from '@angular/platform-browser';
import { DEFAULT_CURRENCY_CODE, ErrorHandler, Injector, LOCALE_ID, NgModule, APP_INITIALIZER } from '@angular/core';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { PipesModule } from './pipes/pipes.module';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { ToastComponent } from './components/shared/toast/toast.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { SpinnerComponent } from './components/shared/spinner/spinner.component';
import { registerLocaleData } from "@angular/common";
import localeEs from "@angular/common/locales/es";
import localeEsExtra from "@angular/common/locales/extra/es";
//import { ServiceWorkerModule } from '@angular/service-worker';
//import { environment } from '../environments/environment';
import { ModalsModule } from './components/modals/modals.module';
import { SignupPageComponent } from './pages/signup-page/signup-page.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared.module';
import { LoginAsComponent } from './components/shared/login-as/login-as.component';
import { TenantAsComponent } from './components/shared/tenant-as/tenant-as.component';
import { RedirectComponent } from './redirect.component';
import { GlobalErrorHandler } from './core/logging/global-error.handler';
import { HttpLoggingInterceptor } from './core/logging/http-logging.interceptor';
import { setAppInjector } from './core/di/app-injector';
import { AuthInterceptor } from './interceptor/auth/auth.interceptor';
import { LoadingInterceptor } from './interceptor/loading/loading.interceptor';
import { ConfigService } from './services/config/config.service';

registerLocaleData(localeEs, "es", localeEsExtra);

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    SpinnerComponent,
    SignupPageComponent,
    TenantAsComponent,
    LoginAsComponent,
    RedirectComponent
  ],
  imports: [
    BrowserModule,
    NgbModule,
    RouterModule,
    ModalsModule,
    HttpClientModule,
    AppRoutingModule,
    PipesModule,
    NgxJsonViewerModule,
    SharedModule,
    ToastComponent,
    NgbTooltipModule,
    NavbarComponent,
    //ServiceWorkerModule.register('ngsw-worker.js', {
    //  enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
    //  registrationStrategy: 'registerImmediately'
    //}),
    BrowserAnimationsModule
  ],
  providers: [
  ConfigService, { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [ConfigService], multi: true },
  { provide: ErrorHandler, useClass: GlobalErrorHandler },
  { provide: HTTP_INTERCEPTORS, useClass: HttpLoggingInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: LOCALE_ID, useValue: 'es' },
  { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
  { provide: LocationStrategy, useClass: PathLocationStrategy },
  { provide: 'googleTagManagerId', useValue: 'GTM-MLQ5WDZH' }
],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector: Injector) {
    setAppInjector(injector);
  }
 }

 export function initializeApp(configService: ConfigService) {
  return () => configService.loadConfig();
}
